module.exports = __webpack_public_path__ + "media/loading-screens/meal-pouch-with-bowl-and-yellow-hearts-illustration--sprite-87bfeb81.svg";